import React from 'react';
import { Redirect } from 'react-router-dom';

// User profile
import UserProfile from '../pages/Authentication/UserProfile';

// BestBuy
import BestBuy from '../pages/BestBuy';

// BigCommerce
import BigCommerce from '../pages/BigCommerce';

// Burnsville
import Burnsville from '../pages/Burnsville';

// ChannelAdvisor
import ChannelAdvisor from '../pages/ChannelAdvisor';

// Google Merchant
import GoogleMerchant from '../pages/GoogleMerchant';

// Users
import Users from '../pages/Users';

// MSAL
import MicrosoftAuthorize from '../pages/Microsoft/authorize';
import Microsoft from '../pages/Microsoft';

// Fuse
import Fuse from '../pages/Fuse';
import FuseFamily from '../pages/Fuse/family';
import FuseWorkorders from '../pages/Fuse/workorders';
import FuseWorkorder from '../pages/Fuse/workorder';

// Happy Returns
import HappyReturns from '../pages/HappyReturns';

// Items
import Item from '../pages/Items/view';
import Items from '../pages/Items';
import CreateItem from '../pages/Items/create';
import Subs from '../pages/Items/Substitutes';

import CustomerServiceReturns from '../pages/CustomerService/returns';
import AmazonGiftCards from '../pages/CustomerService/amazon-gift-cards';

// CustomerService
import Tickets from '../pages/CustomerService/tickets';
import Ticket from '../pages/CustomerService/ticket';

// Sourcing
import Orders from '../pages/Sourcing/orders';
import Intake from '../pages/Sourcing/intake';
import IntakeSummary from '../pages/Sourcing/intake-summary';
import Order from '../pages/Sourcing/order';
import Reprint from '../pages/Sourcing/reprint';

// Trucks
import Trucks from '../pages/Sourcing/trucks';
import Truck from '../pages/Sourcing/truck';
import OutboundTruckLabel from '../pages/Sourcing/outbound-truck-label';

// Suppliers
import Suppliers from '../pages/Sourcing/suppliers';
import Supplier from '../pages/Sourcing/supplier';

// Directory
import Directory from '../pages/Directory';
import ViewDirectoryEntry from '../pages/Directory/view';
import CreateDirectoryEntry from '../pages/Directory/create';

// Listings
import Listings from '../pages/Listings';
import ViewListing from '../pages/Listings/view';
import CreateListing from '../pages/Listings/create';
import EditListing from '../pages/Listings/edit';
import Trees from '../pages/Listings/trees';
import Pricing from '../pages/Listings/pricing';
import DuplicateListing from '../pages/Listings/duplicate';

// Offer
import Invoices from '../pages/Offer/index';
import OfferView from '../pages/Offer/view';

// Printers
import Printers from '../pages/Printers';

// Partner API
import PartnerApi from '../pages/PartnerApi';
import PartnerApiDetails from '../pages/PartnerApi/details';
import UcpUtilities from '../pages/UCP';
import SquaretradeReturnsImport from '../pages/Squaretrade/ReturnsImport';

// Profiles
import Profiles from '../pages/Profiles';
import SaveProfile from '../pages/Profiles/save';

// Sales
import Sales from '../pages/Sales';
import Sale from '../pages/Sales/view';
import Returns from '../pages/Sales/returns';

// Slack
import Slack from '../pages/Slack';
import SlackApproval from '../pages/Slack/approve';

// Testers
import Testers from '../pages/Testers';

// TVs
import TVs from '../pages/TVs/index';
import TVLabels from '../pages/TVs/labels';
import LaneLabels from '../pages/TVs/lane-labels';
import TVInduction from '../pages/TVs/induction';
import TVUtilities from '../pages/TVs/utilities';
import TVPallets from '../pages/TVs/pallets';
import TVPallet from '../pages/TVs/view-pallet';
import TVPalletLabels from '../pages/TVs/pallet-labels';
import TVTeardown from '../pages/TVs/teardown';

// Compatibility
import Compatibility from '../pages/Devices';

// Client Api
import ClientApi from '../pages/ClientApi';
import ClientApiDocs from '../pages/ClientApi/Docs/index';

// Logs
import Exceptions from '../pages/Log/exceptions';
import BCFails from '../pages/Log/bcfails';

// Settings
import Settings from '../pages/Settings';
import SettingsUtilities from '../pages/Settings/utilities';
import SQLPage from '../pages/SQL';

// Authentication related pages
import Login from '../pages/Authentication/Login';
import NewPassword from '../pages/Authentication/NewPassword';
import Logout from '../pages/Authentication/Logout';

// Dashboard
import Dashboard from '../pages/Dashboard/index';
import PrintLayout from '../components/PrintLayout';

// Search
import Search from '../pages/Search';
import ElasticSearch from '../pages/ElasticSearch';

const authProtectedRoutes = [
  { path: '/dashboard', component: Dashboard },

  // Search
  { path: '/search', component: Search },

  // profile
  { path: '/profile', component: UserProfile },

  // BestBuy
  { path: '/best-buy', component: BestBuy },

  // Burnsville
  { path: '/burnsville', component: Burnsville },

  // BigCommerce
  { path: '/bc', component: BigCommerce },

  // ChannelAdvisor
  { path: '/ca', component: ChannelAdvisor },

  // Google Merchant
  { path: '/google/merchant', component: GoogleMerchant },

  // Client API
  { path: '/client-api', component: ClientApi },
  { path: '/client-api/docs', component: ClientApiDocs },

  // Fuse
  { path: '/fuse', component: Fuse },
  { path: '/fuse/workorders', component: FuseWorkorders },
  { path: '/fuse/workorder/:id', component: FuseWorkorder },
  { path: '/fuse/:id', component: FuseFamily },

  // Logs
  { path: '/logs/exceptions', component: Exceptions },
  { path: '/logs/bc-fails', component: BCFails },

  // Azure
  { path: '/microsoft', component: Microsoft },
  { path: '/microsoft/authorize', component: MicrosoftAuthorize },

  // Users
  { path: '/users', component: Users },

  // Customer Service
  { path: '/customer-service/returns', component: CustomerServiceReturns },
  { path: '/customer-service/amazon-gift-cards', component: AmazonGiftCards },
  { path: '/customer-service/tickets', component: Tickets },
  { path: '/customer-service/ticket/:id', component: Ticket },

  // Items
  { path: '/items', component: Items },
  { path: '/item/:id', component: Item },
  { path: '/items/create', component: CreateItem },
  { path: '/items/create/:id', component: CreateItem },

  // Substitutes
  { path: '/items/subs', component: Subs },

  { path: '/sourcing', component: Orders },
  { path: '/sourcing/intake', component: Intake },
  { path: '/sourcing/intake/summary', component: IntakeSummary },
  { path: '/sourcing/suppliers', component: Suppliers },

  // Happy Returns
  { path: '/happy-returns', component: HappyReturns },

  // Listings
  { path: '/listings', component: Listings },
  { path: '/listing/:id', component: ViewListing },
  { path: '/listings/create', component: CreateListing },
  { path: '/listings/create/:itemId/:profileId', component: CreateListing },
  { path: '/listings/edit/:id', component: EditListing },
  { path: '/listings/trees', component: Trees },
  { path: '/logs/pricing', component: Pricing },
  { path: '/listings/duplicate/:id', component: DuplicateListing },

  // Offers
  { path: '/offers', component: Invoices },
  { path: '/offers/:id', component: OfferView },

  // Printers
  { path: '/printers', component: Printers },

  // Partner API
  { path: '/partner-api', component: PartnerApi },
  { path: '/partner-api/:id', component: PartnerApiDetails },
  { path: '/ucp', component: UcpUtilities },
  { path: '/sqtr/returns/import', component: SquaretradeReturnsImport },

  // Profiles
  { path: '/profiles', component: Profiles },
  { path: '/profiles/create', component: SaveProfile },
  { path: '/profiles/edit/:id', component: SaveProfile },

  // Sales
  { path: '/sales', component: Sales },
  { path: '/sales/returns', component: Returns },
  { path: '/sales/:id', component: Sale },

  // Slack
  { path: '/slack', component: Slack },
  { path: '/slack/approve', component: SlackApproval },

  // Testers
  { path: '/testers', component: Testers },

  // TVs
  { path: '/tvs', component: TVs },
  { path: '/tvs/labels', component: TVLabels },
  { path: '/tvs/lane-labels', component: LaneLabels, layout: PrintLayout },
  { path: '/tvs/induction', component: TVInduction },
  { path: '/tvs/utilities', component: TVUtilities },
  { path: '/tvs/pallets', component: TVPallets },
  { path: '/tvs/pallets/:palletId', component: TVPallet },
  { path: '/tvs/pallet-labels', component: TVPalletLabels },
  { path: '/tvs/teardown', component: TVTeardown },

  // Sourcing Orders
  { path: '/sourcing/order/:id', component: Order },
  { path: '/sourcing/reprint/:itemId?', component: Reprint },

  // Trucks
  { path: '/sourcing/trucks', component: Trucks },
  { path: '/sourcing/truck/outbound-label', component: OutboundTruckLabel, layout: PrintLayout },
  { path: '/sourcing/truck/:truckId', component: Truck },

  // Suppliers
  { path: '/sourcing/suppliers', component: Suppliers },
  { path: '/sourcing/supplier/:supplierId', component: Supplier },

  // Directory
  { path: '/directory', component: Directory },
  { path: '/directory/create', component: CreateDirectoryEntry },
  { path: '/directory/entry/:id', component: ViewDirectoryEntry },

  // Compatibility
  { path: '/compatibility', component: Compatibility },

  // settings
  { path: '/sql', component: SQLPage },
  { path: '/settings', component: Settings },
  { path: '/settings/utilities', component: SettingsUtilities },

  // Elastic Search
  { path: '/es', component: ElasticSearch },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: '/', exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: '/logout', component: Logout },
  { path: '/login', component: Login },
  { path: '/reset', component: NewPassword },
];

export { authProtectedRoutes, publicRoutes };
